import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { custTile, tvdData } from '../../types/tvd-types';
import { eroiService } from '../../services/eroi-metric.service';
import {MixpanelService} from "../../../../core/services/mixpanel.service";
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Subscription } from 'rxjs';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';

@Component({
    selector: 'metric-confirmation-box',
    templateUrl: './metric-confirmation-box.component.html',
    styleUrls: ['./metric-confirmation-box.component.scss'],
    standalone: false
})
export class MetricConfirmationBoxComponent implements OnInit, OnDestroy {
  filters: ContractModel | undefined;
  private filtersSubscription: Subscription | undefined;
  private currencySubscription: Subscription | undefined;

  @Input() id: string | undefined= "";
  @Input() selectionMapping: Map<string, [data:tvdData | undefined, isSelected:boolean, isAddedToPres:boolean]> | undefined;
  @Input() customTilesDict : Map<string, custTile> | undefined;
  @Input() filtersSelected : ContractModel | undefined;

  //id maps to both title and units
  title: string | undefined = "title"; // TODO: Remove once all references are modified to pass the EROI ID instead of title to avoid the need for mapping in this component and spec test modified.
  units: string | undefined = "units";
  currencyCode: string = "USD";
  
  pngPath: string | undefined;
  //data pulled from selectionMapping, so it must be set in total-value-delivery.component
  data: tvdData = {monetaryContribution:'', valueContribution:''} ;
  selectedItem : boolean | undefined= false;
  iconPlusHover : boolean = false;

  constructor(
    private _eroiService : eroiService,
    private mixpanelService: MixpanelService,
    private filtersService: FiltersService,
    private currencyUomService: CurrencyUomService
  ) { }

  ngOnInit(): void {
    if(this.id!=undefined){
      this.filtersSubscription = this.filtersService.selectedFiltersObservable.subscribe(f => this.filters = f);
      if(this.filters){
        this.title = this._eroiService.mapIdToTitle(this.id); // TODO: Remove once all references are modified to pass the EROI ID instead of title to avoid the need for mapping in this component and spec test modified.
        this.units = this._eroiService.mapIdToUnits(this.id);
        this.currencyCode = this.currencyUomService.getDisplayedCurrency();

        //if these are blank, check for customTile
        // TODO: Consider refactoring to use a unique identifier for custom tiles instead of relying on title and units being blank which could lead to issues if there are legitimate metrics with blank titles or units or if there are custom tiles with titles and units.
        if(this.title==='' && this.units===''){
          let customTile = this.customTilesDict?.get(this.id);
          if(customTile){
            this.title = customTile.title; // TODO: Consider using a unique identifier for custom tiles instead of relying on title for better reliability in case of title changes or duplicates
            this.units = customTile.unit;
            this.pngPath = this._eroiService.mapIdToGrayIconPath('custom-tile');
          }
        }else{
          this.pngPath = this._eroiService.mapIdToGrayIconPath(this.id);
        }


        let tvdData = this.selectionMapping?.get(this.id)?.[0];
        if(tvdData!=undefined){
          this.data = tvdData;
        }
        this.selectedItem = this.selectionMapping?.get(this.id)?.[1];
      }
    }

    this.currencySubscription = this.currencyUomService.displayedCurrency$.subscribe(() => {
      this.currencyCode = this.currencyUomService.getDisplayedCurrency();
    });
  }

  ngOnDestroy(): void {
    this.filtersSubscription?.unsubscribe();
    this.currencySubscription?.unsubscribe();
  }

  removeItem(units: string| undefined, title: string| undefined,){
    if(this.id!=undefined && this.selectionMapping!=undefined){
      let arr = this.selectionMapping.get(this.id);
      if(arr!=undefined){
        this.selectionMapping?.set(this.id, [arr[0], false, arr[2]]);
      }
      this.selectedItem=false;

      this.trackDeleteClick(title);
    }
  }



  showMetricConfirmationBox(){
    if(this.id!=undefined && this.selectedItem){
      return true;
    }
    else{
      return false;
    }
  }

  trackDeleteClick(title: string| undefined) {
    this.mixpanelService.track('Edit Presentation Clicked', {
      "countriesSelected": this.filtersSelected?.countries,
      "customerNumberSelected": this.filtersSelected?.accts,
      "H5s": this.filtersSelected?.topLevelContractGroup,
      "H7s": this.filtersSelected?.secondLevelContractFilter,
      "periodSelected": this.filtersSelected?.period,
      "Custom Date Range": this.filtersSelected?.dateRange,
      "regionSelected": this.filtersSelected?.regions,
      "templateSelected": this.filtersSelected?.presentationType ? this.filtersSelected.presentationType : 'All',
      "templateTranslationSelected": this.filtersSelected?.translation ? this.filtersSelected.translation : 'English',
      "Page Name": "Total Value Delivered",
      "TVD Metric Removed": title,
    });
  }

}


